<div class="inner_content">
  <div class="card_text">
    <section *ngIf="showUnregisteredContent">
      <h4 class="h6"><strong>Cost effective training to support your H&amp;S accreditation</strong></h4>
      <p>The CHAS online training portal is your gateway to a large library of industry-approved health and safety
        e-learning courses, which are all independently approved to ensure that they comply with industry standards.</p>
      <p>The <strong>CHAS Essentials</strong> bundle includes 10 courses covering all core requirements for just <strong>£95 + VAT per
          trainee</strong>.</p>
    </section>

    <section id="active" *ngIf="showRegisteredContent">
      <ul class="ticks">
        <li *ngFor="let credit of creditBreakdownList">
          {{ credit }}
        </li>
      </ul>

    </section>

    <section *ngIf="showPendingState">
      <p>Your account has been set-up and is currently <strong>pending review</strong>. Please check back in 24 hours.
      </p>
      <p>For further information, please contact Human Focus Support:</p>
      <ul>
        <li><a href="mailto:enquiries@humanfocus.co.uk">enquiries@humanfocus.co.uk</a></li>
        <li><a href="tel:01737 647882">01737 647882</a></li>
      </ul>
    </section>
  </div>
    <div class="card_buttons" *ngIf="showUnregisteredContent">
      <button class="btn btn-primary on_card" (click)="peopleModal.show(); pushGoogleTag();">Buy training bundles and
        get started</button>
    </div>

    <div class="card_buttons" *ngIf="showRegisteredContent">
      <button class="btn btn-primary on_card" [class.is-loading]="isLoading" (click)="loginAsync()"
        *ngIf="activeCard.active">Log in</button>
      <button class="btn btn-primary on_card" (click)="peopleModal.show();pushGoogleTag();">Buy training
        bundles</button>
  </div>

</div>



<div bsModal #peopleModal="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-sizes-name1" class="modal-title pull-left">Online Training</h4>
        <button type="button" class="close pull-right" (click)="peopleModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            <div class="hf-highlight">
              <div>RECOMMENDED</div>
            </div>
            <div class="hf-box">
              <div class="hf-name">CHAS Essentials Bundle</div>
              <div class="hf-price">
                <span style="font-size: smaller">&pound;</span>95
              </div>
              <div class="hf-term">per trainee</div>
              <div class="hf-detail">
                The essential 10-course online training bundle covers all core requirements for an operative:
              </div>
              <div class="hf-detail">
                <p>
                  <i class="fa fa-check"></i> CDM (2015) Awareness
                  <br>
                  <i class="fa fa-check"></i> Fire Safety
                  <br>
                  <i class="fa fa-check"></i> Hand Safety
                  <br>
                  <i class="fa fa-check"></i> Hazardous Substances (COSHH)
                  <br>
                  <i class="fa fa-check"></i> Noise
                  <br>
                  <i class="fa fa-check"></i> Manual Handling
                  <br>
                  <i class="fa fa-check"></i> Near Miss Reporting
                  <br>
                  <i class="fa fa-check"></i> PPE
                  <br>
                  <i class="fa fa-check"></i> Working At Height
                  <br>
                  <i class="fa fa-check"></i> Basic First Aid At Work
                  <br>
                </p>
                <p>Usual price for all listed is &pound;260.00 + VAT per trainee. CHAS member pricing &pound;95.00 + VAT
                  per trainee</p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12">
                <form [formGroup]="purchaseHumanFocusForm">
                  <div class="form-group">
                    <label>Simply choose the course or bundle you'd like to purchase and enter the number of required
                      trainees.</label>
                    <div class="form-group">
                      <input class="form-control" type="number" formControlName="numWorkers"
                        placeholder="Number of workers to be trained" (change)="getQuoteAsync()"
                        (keyup)="getQuoteAsync()" min="1" step="1" oninput="validity.valid||(value='');" />
                    </div>
                  </div>

                  <div class="form-group">
                    <select class="custom-select" formControlName="selectedBundle" (change)="getQuoteAsync()">
                      <option hidden value="" selected>Select a course or bundle:</option>
                      <optgroup [label]="group.name" *ngFor="let group of groupedAvailableBundles">
                        <option *ngFor="let bundle of group.bundles" [ngValue]="bundle">{{bundle.name}}</option>
                      </optgroup>
                    </select>
                  </div>
                </form>
              </div>
              <div class="col-md-12">
                <div class="">

                  <app-quote-container [amount]="quotePrice" [loading]="loadingQuote" [title]="'Price:'"
                    [showVatLabel]="quoteHasVat"></app-quote-container>

                  <button type="button" class="btn btn-primary payNow" (click)="activateAync()"
                    [class.is-loading]="modalbtnLoading" [disabled]="payButtonDisabled">
                    Pay now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="powered-by">
        <div class="row">
          <div class="col-md-6">
            <a class="btn btn-light btn-back" (click)="peopleModal.hide()">
              <i class="fa fa-angle-double-left"></i> Go back
            </a>
          </div>
          <div class="col-md-6">
            <div class="powered-by-text">Powered by<br>
              <img
                src="data:image/png;base64,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">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
